<div class="right" mat-dialog-title>
  <button
    (keyup.space)="onCancel()"
    (keyup.enter)="onCancel()"
    onmouseover="this.focus()"
    onmouseout="this.blur()"
    (click)="onCancel()"
    mat-button
    [mat-dialog-close]="false"
    class="close-button"
    aria-label="close"
  >
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="center">
    <h2 class="verify-title" [id]="headingId">
      Get Your ID and Mobile Device Ready to Continue
    </h2>
    <div class="mobile-icon"></div>
  </div>
  <br />
  <p class="center">
    You will need your ID and mobile device to move forward with your
    application. Ready?
  </p>
</div>
<br />
<div class="center">
  <button
  class="primary-btn-action"
    mat-flat-button
    color="primary"
    [mat-dialog-close]="true"
  >
    Ready
  </button>
</div>
<br />
